import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { PAGE_RENDER_TYPE, SIDEMENU_MODE } from '@maxis/client-logic/constants/enumerates';
import { TextInput } from '@maxis/components';
import layoutStyles from './Layout.module.css';
// import styles from './SideMenu.module.css';
import styles from './_sideMenu.module.css';
import SideMenuFavoriteTab from './SideMenuFavoriteTab';
import SideMenuSearchTab from './SideMenuSearchTab';
import SideMenuMainTab from './SideMenuMainTab';

import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { shallow } from 'zustand/shallow';
// import useFetch from '@maxis/client-logic/hooks/useFetch';
import { LOCAL_STORAGE_KEYS, AUTH } from '@maxis/client-logic/constants/enumerates';
import { setLocalStorageItem } from '@maxis/client-logic/utils/localStorageUtil';
import { HOME_MENU_ID } from '@maxis/client-logic/constants/constMenuId';
import useTabMenu from '@maxis/client-logic/hooks/useTabMenu';
import useFetch from '@maxis/client-logic/hooks/useFetch';

const AI_NATIVE_HUB_MENU_ID = 'AI_NATIVE_HUB';
const USE_ANH = window.__ENV__?.USE_ANH === 'true';

/*
 * DB(tb_tool_info) 조회 기반 — 다시 쓸 때 주석 해제 + 아래 resolveAnhUrlFromEnv / useMemo 제거, useFetch 복구
 *
 * function buildAnhOpenUrl(row) {
 *     if (!row || typeof row !== 'object') return '';
 *     const raw = String(row.url ?? row.URL ?? '').trim();
 *     if (!raw) return '';
 *     const portVal = row.external_port ?? row.EXTERNAL_PORT;
 *     const port =
 *         portVal !== undefined && portVal !== null && String(portVal).trim() !== ''
 *             ? String(portVal).trim()
 *             : '';
 *     let base = raw.replace(/\/$/, '');
 *     const hasPortInUrl = /:\d{2,5}(\/|$)/.test(base);
 *     if (port && !hasPortInUrl) {
 *         base = `${base}:${port}`;
 *     }
 *     return base.endsWith('/') ? base : `${base}/`;
 * }
 */

/** VITE_AI_NATIVE_HUB_URL 상대경로(/anh/ 등) → 새 탭용 절대 URL */
function resolveAnhUrlFromEnv() {
    const raw = import.meta.env.VITE_AI_NATIVE_HUB_URL?.trim() ?? '';
    if (!raw) return '';
    try {
        return new URL(raw, window.location.origin).href;
    } catch {
        return '';
    }
}

const SideMenu = () => {
    const tabMenuList = useBoundStore((state) => state.tabMenu.menuList);
    const { menuList, pageRenderType, setSelectedMenu, showTopMenuYn, selectedTopMenu } =
        useBoundStore((state) => state.menu, shallow);

    const userId = useBoundStore((state) => state.user.userId);
    
    const { authLists } = useBoundStore((state) => state.user, shallow);
    const exists = authLists?.some((item) => AUTH?.includes(item.authorityId)) || false;
    const showAnh = menuList?.some((item) => item.menuId === 'ANH' && item.displayYn);
    
    const { request } = useFetch();
    const refSearch = useRef();
    const [sideMenuMode, setSideMenuMode] = useState(SIDEMENU_MODE.MENU);
    const [width, setWidth] = useState(0);
    const [show, setShow] = useState(false);
    const [searchMenuRslt, setSearchMenuRslt] = useState([]);
    const aiNativeHubUrl = useMemo(() => resolveAnhUrlFromEnv(), []);
    const { changeTab } = useTabMenu();

    const navigate = useNavigate();
    const { pathname } = useLocation();

    const onMenuHide = () => {
        setWidth(0);
        searchMenu(false);
    };

    const onMenuShow = () => {
        setWidth(230);
    };

    const onSideMenuMode = (mode) => {
        setSideMenuMode(mode);
    };

    const onMenuClick = (d) => {
        if (d) {
            // search menu close
            setShow(false);
            refSearch.current?.clear();
            // 그리드 개인화 기능을 위한 메뉴ID 인식.
            setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, d.menuId);

            setSelectedMenu({
                menuId: d.menuId,
                menuName: d.menuName,
                sideYn: d.sideYn,
                displayYn: d.displayYn,
                menuNameList: d.menuNameList,
            });
            if (d.programRoutePath) {
                navigate(import.meta.env.VITE_PUBLIC_URL + d.programRoutePath);

                let chk = tabMenuList.filter((x) => {
                    return x.menuId === d.menuId;
                });

                if (!chk.length) {
                    const param = { PGM_ID: d.menuId };

                    const backendType = import.meta.env.VITE_BACKEND_TYPE; // JAVA or DOTNET
                    if (backendType === 'DOTNET') {
                        // request(`/menuLog`, { method: 'post', body: param });
                    }
                }
            }
        }
    };

    const searchMenu = async (b) => {
        const value = refSearch.current?.getValue();
        setShow(b);
        if (b) {
            const rslt = menuList.filter((x) => {
                return x.menuName.toLowerCase().search(value.toLowerCase()) !== -1;
            });
            setSearchMenuRslt(rslt);
        } else {
            refSearch.current?.clear();
        }
    };

    const changeValue = () => {
        if (!refSearch.current.getValue()) {
            setShow(false);
        }
    };

    const systemButtonHandle = (e) => {
        e.preventDefault();
        navigate(import.meta.env.VITE_PUBLIC_URL + '/system/board');
    };

    const isAiNativeHubActive = (() => {
        if (!aiNativeHubUrl) {
            return pathname.includes('rag-hub');
        }
        try {
            const u = new URL(aiNativeHubUrl, window.location.origin);
            if (u.origin === window.location.origin) {
                const p = u.pathname.replace(/\/$/, '') || '/';
                return pathname === p || pathname.startsWith(`${p}/`);
            }
        } catch {
            /* ignore */
        }
        return pathname.includes('rag-hub');
    })();

    const aiNativeHubClick = () => {
        setShow(false);
        refSearch.current?.clear();
        const param = { USER_ID: userId }
        request(`/token/getNewToken`, 
            { method: 'post', body: param }, 
            { showConfirm: false, showLoad: false }
        ).then(res =>{
            const { ACCESS_TOKEN } = res || {};
            if(ACCESS_TOKEN) setLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, ACCESS_TOKEN)
        });
        setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, AI_NATIVE_HUB_MENU_ID);
        setSelectedMenu({
            menuId: AI_NATIVE_HUB_MENU_ID,
            menuName: 'AI Native Hub',
            sideYn: 'Y',
            displayYn: 'Y',
            menuNameList: 'AI Native Hub',
        });
        window.open(aiNativeHubUrl, '_blank', 'noopener,noreferrer');
    };

    const aiNativeHubButtonHandle = (e) => {
        e.preventDefault();
        aiNativeHubClick();
    };

    const showBottomSection = USE_ANH || showAnh || exists;

    useEffect(() => {
        if (menuList?.length > 0) {
            onMenuShow();
        } else {
            onMenuHide();
        }
    }, [menuList]);

    /*
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const response = await request(
                    null,
                    {
                        serviceId: 'Srv010Service',
                        process: [{ getAnhInfo: 'ANH URL 조회' }],
                    },
                    { showConfirm: false, showLoad: false }
                );
                const row = response?.data?.result;
                const url = buildAnhOpenUrl(row);
                if (!cancelled && url) {
                    setAiNativeHubUrl(url);
                }
            } catch {
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [request]);
    */

    const setHome = (m) => {
        // 그리드 개인화 기능을 위한 메뉴ID 인식
        setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, m);

        setSelectedMenu({
            menuId: m,
            menuName: 'home',
            sideYn: 'Y',
            displayYn: 'Y',
            menuNameList: 'home',
        });

        changeTab(m);
    };

    return (
        <div className={layoutStyles.sidemenu}>
            <div className={`${styles.nav} ${width === 0 ? styles.invisible : styles.visible}`}>
                <SideMenuMainTab
                    sideMenuMode={sideMenuMode}
                    showAllMenuInSide={showTopMenuYn === 'Y' ? false : true}
                    onMenuClick={onMenuClick}
                />
                {showBottomSection ? (
                    <div className={styles.bottom}>
                        <ul>
                            {(USE_ANH && showAnh) ? (
                                <li key="ai-native-hub">
                                    <a
                                        className={isAiNativeHubActive ? styles.on : undefined}
                                        onClick={aiNativeHubButtonHandle}
                                    >
                                        <i translate="no" className="material-symbols-outlined">hub</i>
                                        <p>AI Native Hub</p>
                                    </a>
                                </li>
                            ) : null}
                            {exists ? (
                                <li>
                                    <a
                                        className={
                                            pathname.includes('/system') ? styles.on : undefined
                                        }
                                        onClick={systemButtonHandle}
                                    >
                                        <i translate="no" className="material-symbols-outlined">settings</i>
                                        {/* 상단 메뉴(Project, Node, ...)와 같은 영문 표기 */}
                                        <p>System</p>
                                    </a>
                                </li>
                            ) : null}
                        </ul>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

SideMenu.displayName = 'SideMenu';
export default SideMenu;
